<template>
  <div class="w-5 h-5 flex items-center justify-center">
    <svg v-if="status === 'all'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="6.82843" cy="12.4851" r="2" transform="rotate(-45 6.82843 12.4851)" fill="#C1C7D0"/>
      <circle cx="12.4852" cy="6.82837" r="2" transform="rotate(-45 12.4852 6.82837)" fill="#40C4AA"/>
    </svg>
    <svg v-else xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
      <circle cx="3" cy="3" r="3" :fill="status === 'live' ? '#00AB75' : '#C0C7D1'" />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'HookLiveStatusIcon',
  props: {
    status: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped></style>